// import React from 'react';
// import { useState, useEffect } from 'react';
// import {Link} from 'react-router-dom';

// const Products = () => {
//   const [products, setProducts] = useState([]);


//   useEffect(() => {
//     fetch('https://fakestoreapi.com/products')
//       .then(res => res.json())
//       .then(json => setProducts(json))
//       .catch(err => console.log(err));
//   }, []);

//   return (
//     <>
//       <section className="products container">
//         <article>
//           {products.map((product) => (
//             <div className="item" key={product.id}>
//               <Link to="/">
//                 <img src={product.image} alt={product.title} />
//                 <h3>{product.title}</h3>
//                 <p>${product.price}</p>
//               </Link>
//             </div>
//           ))}
//         </article>
//       </section>
//     </>
//   );
// }

// export default Products;
// import React, {useState,useEffect} from 'react';
import { useContext } from 'react';
import { Link } from 'react-router-dom';
import ProductsContext from '../context/ProductsContext';
// import ProductsContext from '../context/ProductsContext';

const Products = () => {
  // const [products, setProducts] = useState([]);

  // useEffect(() => {
  //   fetch('https://fakestoreapi.com/products')
  //     .then(res => res.json())
  //     .then(json => setProducts(json))
  //     .catch(err => console.log(err));
  // }, []);
  
  const {products,setProducts} = useContext(ProductsContext);


  return (
    <section className="products container">
      <article>
        {products.map((product) => (
          <div className="item" key={product.id}>
            <Link to={`/product/${product.id}`}>
              <img src={product.image} alt={product.title} />
              <h3>{product.title}</h3>
              <p>${product.price}</p>
            </Link>
          </div>
        ))}
      </article>
    </section>
  );
}

export default Products;

